import {
  CHANGED_PROJECT_VALUE_ACTION,
  CHANGED_PROJECT_ID_ACTION,
  LOADED_PROJECT_ACTION,
  CHANGED_PROJECT_CHANGED_AVALIACAO,
  CLEARED_PROJECT_ACTION,
  LOADED_HISTORICO_AVALIACOES_ACTION,
  LOADED_PROJETOS_PAGE_ACTION,
  CLEARED_PROJETOS_PAGE_ACTION,
  PROJECT_ADDEDED_DOCUMENT_ACTION,
  PROJECT_EDITED_DOCUMENT_ACTION,
  PROJECT_REMOVED_DOCUMENT_ACTION,
  RESETED_PROJETOS,
  LOADING_REMOVE_PROJECT_ACTION,
  DOWNLOADING_PROJETO_PDF_ACTION,
} from './ProjetoActions';
import { TOTAL_ITEMS_FOR_PAGE } from '../../utils/PaginationUtils';
import { transformNullIntoEmpty } from '../../utils/DataUtils';
import { indexOfObject } from '../../utils/ArrayUtils';

export const FIXED_PRINCIPOS_VALORES = [1, 2];

const PAGE_LIST_INITIAL_STATE = {
  status: -1,
  coop: -1,
  idEstado: -1,
  busca: '',
  nomCidade: '',
  dataInicio: '',
  dataFim: '',
  page: -1,
  totalElements: 0,
  totalPages: 0,
  elements: [],
};

const PROJECT_EDITING_NOT_NULL_PROPS = [
  'periodoInicial',
  'periodoFinal',
  'codigoCooperativa',
  'descricaoTurma',
  'nome',
  'dataCadastro',
  'dataAlteracao',
  'justificativa',
  'descricaoPerguntaExploratoria',
  'descricaoTerritorioInvestigado',
  'descricaoObjetivoExpedicao',
  'descricaoExpedicao',
  'descricaoPerguntas',
  'descricaoIndiceInicial',
  'descricaoIndiceFormativo',
  'descricaoComponenteCurricular',
  'descricaoAtividadeDesenvolvida',
  'descricaoPrincipioValor',
  'descricaoComunidadeAprendizagem',
  'descricaoAtividadeIntegradora',
  'descricaoIndiceFinal',
  'descricaoMostraPedagogica',
];

const PROJETO_EDITING_INITIAL_STATE = {
  /* integer */
  id: null,

  /* string */
  periodoInicial: '',

  /* string */
  periodoFinal: '',

  /* string */
  codigoCooperativa: '',

  /* string[] */
  cpfsAssessores: [],

  /* string[] */
  cpfsProfessores: [],

  /* boolean */
  direitoImagem: false,

  /* string */
  descricaoTurma: '',

  /* integer */
  idEscola: -1,

  /* integer[] */
  idEtapasEnsino: [],

  /* string */
  idUsuario: 'teste_ldap',

  /* Nome do projeto */
  nome: '',

  /* integer */
  quantidadeAlunosTurma: 0,

  /* string date */
  dataCadastro: '2019-04-05T15:15:59',
  dataAlteracao: '2019-04-05T17:19:08',

  /* string */
  justificativa: '',

  /* boolean */
  consultaPublica: true,

  /* object[]
  [
    {
      comentario	string
      cpfAcessor	string
      etapa	integer($int32) ( 0 ... )
      status	integer($int32) ( 0 - rascunho / 1 - pendente / 2 - aprovado / 3 - rejeitado )
      existe	boolean
    }
  ]
  */
  avaliacoes: [],

  /* boolean */
  cienciaCordenador: undefined,

  /* string */
  descricaoPerguntaExploratoria: null,

  /* string */
  descricaoTerritorioInvestigado: null,

  /* string */
  descricaoObjetivoExpedicao: null,

  /* string */
  descricaoExpedicao: null,

  /* string */
  descricaoPerguntas: null,

  /* string */
  descricaoIndiceInicial: null,

  /* string */
  descricaoIndiceFormativo: null,

  /* string */
  descricaoComponenteCurricular: null,

  /* string */
  descricaoAtividadeDesenvolvida: null,

  /* integer[] */
  idPrincipiosValores: FIXED_PRINCIPOS_VALORES,

  /* string */
  descricaoPrincipioValor: null,

  /* string */
  descricaoComunidadeAprendizagem: null,

  /* string */
  apoiadores: null,

  /* string */
  descricaoAtividadeIntegradora: null,

  /* string */
  descricaoIndiceFinal: null,

  /* string */
  descricaoMostraPedagogica: null,

  /* object[]
  [
    {
      id	integer
      etapa	integer
      idProjeto integer
      cooperativa string
      tipo string
      caminho string
      base64 string
      capa boolean
    }
  ]
  */
  documentos: [],

  /* array[object[]]
  [
    [
      {
        comentario: string,
        nomeAssessor: string,
        cpfAssessor: string,
        dataCadastro: string,
        etapa: integer,
        status: integer
      }
    ]
  ]
  */
  historico: [],
  checkCoordenador: false,
  checkProfGestor: false,
};

const INITIAL_STATE = {
  pageSize: TOTAL_ITEMS_FOR_PAGE,

  pageList: PAGE_LIST_INITIAL_STATE,

  projetoEditing: PROJETO_EDITING_INITIAL_STATE,

  loadingRemoveProjeto: false,

  generatingPdfById: [],
};

const getNovasAvaliacoes = (atuais, nova) => {
  let avaliacoes = JSON.parse(JSON.stringify(atuais.avaliacoes || {}));
  avaliacoes[nova.etapa] = nova;
  return avaliacoes;
};

const getHistorico = (state, novoHistorico, etapa) => {
  let historico = [...(state.historico || [])];
  historico[etapa] = novoHistorico;
  return historico;
};

const getRefreshedPageList = (lastPageList, newPageList) => {
  return {
    ...lastPageList,
    coop: newPageList.coop,
    status: newPageList.status,
    busca: newPageList.busca,
    dataInicio: newPageList.dataInicio,
    dataFim: newPageList.dataFim,
    idEstado: newPageList.idEstado,
    nomCidade: newPageList.nomCidade,
    page: newPageList.page,
    totalElements: newPageList.totalElements,
    totalPages: newPageList.totalPages,
    elements: [...lastPageList.elements, ...newPageList.elements],
  };
};

const getDocumentListAdded = (lastDocumentList, newDocument) => {
  let newList = [...lastDocumentList];
  newList.push(newDocument);
  return newList;
};

const getDocumentListRemoved = (lastDocumentList, id) => {
  let newList = [...lastDocumentList];
  const documentIndex = indexOfObject(newList, 'id', id);
  if (documentIndex > -1) {
    newList.splice(documentIndex, 1);
  }
  return newList;
};

const getDocumentListEdited = (lastDocumentList, document) => {
  let newList = [...lastDocumentList];
  const documentIndex = indexOfObject(newList, 'id', document.id);
  if (documentIndex > -1) {
    newList[documentIndex] = {
      ...document,
    };
  }
  return newList;
};

const getProjectAvaliacoesOrdered = (avaliacoes) => {
  return [
    ...avaliacoes.sort(
      (avaliacao1, avaliacao2) => avaliacao1.etapa - avaliacao2.etapa
    ),
  ];
};

const getProjectLoadedFormatted = (project) => {
  return {
    ...project,
    avaliacoes: getProjectAvaliacoesOrdered(project.avaliacoes),
  };
};

const refreshGeneratingPdfById = (arr, action) => {
  let ids = [...arr];
  if (action.loading) {
    if (ids.indexOf(action.id) === -1) {
      ids.push(action.id);
    }
  } else {
    const foundIndex = ids.indexOf(action.id);
    if (foundIndex > -1) {
      ids.splice(foundIndex, 1);
    }
  }
  return ids;
};

export default function ProjetoReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case RESETED_PROJETOS:
      return {
        ...INITIAL_STATE,
      };
    case PROJECT_ADDEDED_DOCUMENT_ACTION:
      return {
        ...state,
        projetoEditing: {
          ...state.projetoEditing,
          documentos: getDocumentListAdded(
            state.projetoEditing.documentos,
            action.payload
          ),
        },
      };
    case PROJECT_REMOVED_DOCUMENT_ACTION:
      return {
        ...state,
        projetoEditing: {
          ...state.projetoEditing,
          documentos: getDocumentListRemoved(
            state.projetoEditing.documentos,
            action.payload
          ),
        },
      };
    case PROJECT_EDITED_DOCUMENT_ACTION:
      return {
        ...state,
        projetoEditing: {
          ...state.projetoEditing,
          documentos: getDocumentListEdited(
            state.projetoEditing.documentos,
            action.payload
          ),
        },
      };
    case LOADED_PROJETOS_PAGE_ACTION:
      return {
        ...state,
        pageList: getRefreshedPageList(state.pageList, action.payload),
      };
    case CLEARED_PROJETOS_PAGE_ACTION:
      return { ...state, pageList: PAGE_LIST_INITIAL_STATE };
    case LOADED_HISTORICO_AVALIACOES_ACTION:
      return {
        ...state,
        projetoEditing: {
          ...state.projetoEditing,
          historico: getHistorico(
            state.projetoEditing,
            action.payload.historico,
            action.payload.etapa
          ),
        },
      };
    case CLEARED_PROJECT_ACTION:
      return {
        ...state,
        projetoEditing: PROJETO_EDITING_INITIAL_STATE,
      };
    case CHANGED_PROJECT_CHANGED_AVALIACAO:
      return {
        ...state,
        projetoEditing: {
          ...state.projetoEditing,
          avaliacoes: getNovasAvaliacoes(state.projetoEditing, action.payload),
        },
      };
    case CHANGED_PROJECT_VALUE_ACTION:
      return {
        ...state,
        projetoEditing: {
          ...state.projetoEditing,
          [action.payload.name]: action.payload.value,
        },
      };
    case LOADED_PROJECT_ACTION:
      return {
        ...state,
        projetoEditing: getProjectLoadedFormatted(
          transformNullIntoEmpty(
            {
              ...state.projetoEditing,
              ...action.payload,
            },
            PROJECT_EDITING_NOT_NULL_PROPS
          )
        ),
      };
    case CHANGED_PROJECT_ID_ACTION:
      return {
        ...state,
        projetoEditing: {
          ...state.projetoEditing,
          id: action.payload,
        },
      };
    case LOADING_REMOVE_PROJECT_ACTION:
      return {
        ...state,
        loadingRemoveProjeto: action.payload,
      };
    case DOWNLOADING_PROJETO_PDF_ACTION:
      return {
        ...state,
        generatingPdfById: refreshGeneratingPdfById(
          state.generatingPdfById,
          action.payload
        ),
      };
    default:
      return state;
  }
}
